'use strict';

var cart = require('../cart/cart');

var updateMiniCart = true;

module.exports = function () {
    cart();

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    // hide minicart on orientation change from tablet landscape to portrait and back to landscape
    window.jRes.addFunc([
        {
            breakpoint: ['xsmall', 'small', 'medium'],
            enter: function () {
                $('.minicart .popover').removeClass('show');
            }
        }
    ]);

    $('.minicart').on('mouseenter focusin touchstart', function () {
        if ($('.search:visible').length === 0 || $('.minicart-popover-wrap:visible').length === 0) {
            return;
        }
        var url = $('.minicart').data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (count !== 0 && $('.minicart .popover.show').length === 0) {
            if (!updateMiniCart) {
                var $minicartSlider = $('.js-minicart-recommendation-slider');
                $('.minicart .popover').addClass('show');

                if ($minicartSlider.length > 0) {
                    $minicartSlider[0].slick.refresh();
                    $(window).trigger('alignTiles', {container: $minicartSlider, resetHeight: true});
                }

                return;
            }

            $('.minicart .popover').addClass('show');
            $('.minicart .popover').spinner().start();
            $.get(url, function (data) {
                $('.minicart .popover').empty();
                $('.minicart .popover').append(data);
                updateMiniCart = false;
                $.spinner().stop();

                $(document).trigger('miniCart:open', data);
            });
        }
    });

    $('body').on('touchstart click', function (e) {
        if ($('.minicart').has(e.target).length <= 0) {
            $('.minicart .popover').removeClass('show');
        }
    });

    $('.minicart').on('mouseleave focusout', function (event) {
        if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0)
            || (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
            || $('body').hasClass('modal-open')) {
            event.stopPropagation();
            return;
        }
        $('.minicart .popover').removeClass('show');
    });
    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });
    $('body').on('product:afterAddToCart', function () {
        updateMiniCart = true;
    });
    $('body').on('cart:update', function () {
        updateMiniCart = true;
    });

    $('body').on('keydown', function (event) {
        if (event.keyCode === 27) {
            $('.minicart .popover').removeClass('show');
        }
    });
};
